import Typewriter from 'typewriter-effect';
import style from './hero.module.css';

export default function Hero() {
  return (
    <div className={style.hero} id="hero">
      <div className={style.content}>
        <p>I am a</p>
        <h1>
          <Typewriter
            options={{
              strings: [
                'HTML Email Developer',
                'Web Developer',
                'Software Engineer',
              ],
              autoStart: true,
              loop: true,
            }}
          />
        </h1>
        <p>Based in Los Angeles</p>
      </div>
      <div className={style.overlay}></div>
    </div>
  );
}
